function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 17a1 1 0 0 1 1-1 4 4 0 1 0-4-4 1 1 0 1 1-2 0 6 6 0 1 1 7 5.917V19a1 1 0 1 1-2 0v-2zm1 15C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-2c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0-4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
});

var SvgAlertHelp = function SvgAlertHelp(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "f8019854a426e0fa27175695d34cd26c.svg";
export { SvgAlertHelp as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/alert-help.svg
// module id = null
// module chunks = 